import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { DEFAULT_SCHEDULE } from 'components/powerFlowShared/components/modals/openinghours/constants';
import { createOpeningHoursModal, } from '../../components/modals/openingHours';
const FORM_NAME = 'openingHoursForm';
const mapStateToProps = (_state, { node: { payload } }) => {
    const initialValues = {
        schedule: (payload === null || payload === void 0 ? void 0 : payload.schedule) || DEFAULT_SCHEDULE,
        timezone: (payload === null || payload === void 0 ? void 0 : payload.timezone) || moment.tz.guess(true),
    };
    return {
        initialValues,
    };
};
export const createOpeningHoursModalContainer = (isDeprecated) => connect(mapStateToProps)(reduxForm({
    enableReinitialize: true,
    form: FORM_NAME,
    touchOnBlur: false,
    validate: () => ({}),
})(createOpeningHoursModal(isDeprecated)));
